module.exports = "Click Download Images button to get a zip file with all your compressed images"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoCompress/photo-compress-how-to-step-two.md
// module id = 1157
// module chunks = 0